import { environmentHttpClient } from "client/Api/httpClient";

export type MobileApp = {
	latestVersion: string;
	downloadUrl: string;
};

export type MobileAppWellknown = {
	publicEnvironmentName: string;
	android: MobileApp;
	iOs: MobileApp;
};

export function getMobileAppInfo(signal?: AbortSignal): Promise<MobileAppWellknown> {
	return environmentHttpClient.get<MobileAppWellknown>(
		".well-known/mobile-app",
		undefined,
		{ signal }
	);
}